import { render, staticRenderFns } from "./TagView.vue?vue&type=template&id=5b66e938&scoped=true&lang=pug&"
import script from "./TagView.vue?vue&type=script&lang=js&"
export * from "./TagView.vue?vue&type=script&lang=js&"
import style0 from "./TagView.vue?vue&type=style&index=0&id=5b66e938&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b66e938",
  null
  
)

export default component.exports